import { MasterDetailListEntry } from "@sdbn/common";



export class TransportCreationProfileNumberPlate {
  numberPlate: string | null;
  active: boolean;
  deleted: boolean;

  constructor(entry?: any) {
    if (entry != null) {
      this.numberPlate = entry.numberPlate;
      this.active = entry.active;
    }
  }
}

export class TransportCreationProfile implements MasterDetailListEntry {
  id: number;
  active: boolean = true;
  allowParallelAccess: boolean = false;
  withRouting = false;

  name: string;
  hashCode: string;

  carrier: string;
  driver: string;
  numberPlate: string;
  orderReference: string;

  transportCreationProfileNumberPlates: TransportCreationProfileNumberPlate[] = [];

  optionIds = new Array<number>();

  hasNumberPlateList: boolean;
  hasActionTablet: boolean;
  hasQrCode: boolean;

  displayName: string;

  constructor(profile?: any) {
    if (profile != null) {
      this.id = profile.id;
      this.name = profile.name;
      this.active = profile.active;
      this.hashCode = profile.hashCode;
      this.carrier = profile.carrier;
      this.driver = profile.driver;
      this.allowParallelAccess = profile.allowParallelAccess;
      this.withRouting = profile.withRouting;
      this.numberPlate = profile.numberPlate;
      this.orderReference = profile.orderReference;
      if (profile.optionIds != null) {
        for (const id of profile.optionIds) {
          this.optionIds.push(id);
        }
      }
      this.hasNumberPlateList = profile.hasNumberPlateList;
      this.hasActionTablet = profile.hasActionTablet;
      this.hasQrCode = profile.hasQrCode;

      this.displayName = profile.displayName;
      for (const transportCreationProfileNumberPlate of profile.transportCreationProfileNumberPlates) {
        this.transportCreationProfileNumberPlates.push(
          new TransportCreationProfileNumberPlate({
            numberPlate: transportCreationProfileNumberPlate.numberPlate,
            active: transportCreationProfileNumberPlate.active,
          })
        );
      }
    }
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return this.hashCode;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }
}
